var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',[(!_vm.hideName)?[_c('p',{staticClass:"mb-0"},[_c('b',[_vm._v(_vm._s(_vm.name || 'Job History'))])])]:_vm._e(),_vm._v(" "),_vm._l(((_vm.value || [])),function(ref){
var jobTitle = ref.jobTitle;
var companyTitle = ref.companyTitle;
var startDate = ref.startDate;
var endDate = ref.endDate;
return _c('p',{key:(jobTitle + "-" + companyTitle),staticStyle:{"line-height":"1.2rem"}},[_c('span',[_vm._v(_vm._s(jobTitle)+_vm._s(companyTitle ? (" (at " + companyTitle + ")") : ''))]),_vm._v(" "),(startDate)?[_c('br'),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatDate(startDate, 'MMM YYYY'))+" - "+_vm._s(endDate ? _vm.formatDate(endDate, 'MMM YYYY') : ''))])]:_vm._e()],2)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66e259ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/JobHistoryShow.vue
// module id = Al+V
// module chunks = 0 112